import { EntityId } from "@reduxjs/toolkit";
import { Port } from "types/Port";
import { Stack, InputLabel } from "@mui/material";
import { PortControl } from "./PortControl";

export interface PortTypeSectionProps {
    sectionName: string;
    siteId: EntityId;
    ports: Port[];
    activePortIcon: React.ReactNode;
    inactivePortIcon: React.ReactNode;
}

export function PortTypeSection(props: PortTypeSectionProps) {
    return (
        <Stack spacing={1}>
            <InputLabel>{props.sectionName}</InputLabel>
            {props.ports &&
                props.ports.length > 0 &&
                props.ports.map((port) => (
                    <PortControl
                        key={`${props.siteId}-${port.name}`}
                        siteId={props.siteId}
                        port={port}
                        activeIcon={props.activePortIcon}
                        inactiveIcon={props.inactivePortIcon}
                    ></PortControl>
                ))}
            {props.ports && props.ports.length === 0 && "No ports available"}
        </Stack>
    );
}
